/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton, NeuFeedback } from '@neutron/react';

export const StyledExportCsvBtn = styled(NeuButton)`
  > button {
    font-size: 1rem;
    margin-right: 0.25rem;
  }
`;

export const TinySpinner = styled(NeuFeedback)`
  > svg {
    height: 20px !important;
    width: 20px !important;
  }
`;
